"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.952 3.89c2.042-1.268 4.703-1.315 7.088.738a.7.7 0 0 1-.914 1.06c-1.91-1.643-3.9-1.562-5.436-.61-.864.537-1.594 1.358-2.078 2.334h3.32a.7.7 0 1 1 0 1.4H7.118c-.09.413-.14.84-.14 1.275q.001.42.062.825h3.89a.7.7 0 1 1 0 1.4H7.44a5.64 5.64 0 0 0 2.241 2.604c1.553.934 3.563 1.027 5.472-.453a.7.7 0 1 1 .858 1.107c-2.385 1.85-5.026 1.765-7.052.545-1.387-.835-2.48-2.197-3.017-3.803H4.417a.7.7 0 1 1 0-1.4H5.63a7 7 0 0 1-.05-.825q.002-.649.113-1.275H4.417a.7.7 0 1 1 0-1.4h1.667c.572-1.476 1.594-2.732 2.868-3.523",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyEuroIcon20.js.map